import { Theme } from '@mui/material/styles'

const muiInputLabel = (theme: Theme) => {
  return {
    defaultProps: {
      shrink: true,
      disableAnimation: true
    },
    styleOverrides: {
      root: {
        marginBottom: '0.5rem',
        lineHeight: 1.25,
        color: theme.palette.text.primary,
        position: 'relative',
        top: '0',
        bottom: 'auto',
        transform: 'initial'
      },
      asterisk: {
        color: theme.palette.error.main
      }
    }
  }
}

export default muiInputLabel
